import React from 'react';
import type { Hero } from 'types/hero';

import { Wrap, Button } from '@leafwell/components';

import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';
import Figure from './figure';

const HeroEmployers: React.FC<Hero> = ({
  title,
  description,
  image,
  button,
}) => {
  return (
    <Wrap tagName="header" spacer={true}>
      <div className="text-center grid gap-y-8 md:max-w-5xl justify-self-center justify-items-center">
        <HeadingBody
          {...{
            level: '1',
            tagName: 'h1',
            title: title,
            className: 'font-semibold',
          }}
        />
        <WysiwygContent
          content={description}
          className="md:max-w-xl !text-lg xl:!text-xl"
        />
        {button && (
          <Button
            href={button.url}
            label={button.title}
            rounded={true}
            filled={true}
            variant="secondary"
            target={button.target}
            className="w-full md:w-fit h-fit"
          />
        )}
        {image && <Figure className="mt-8" {...image} />}
      </div>
    </Wrap>
  );
};

export default HeroEmployers;
